import { Component, DOCUMENT, inject, OnInit } from '@angular/core'
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog'

import { Router } from '@angular/router'
import { ROLES } from 'src/app/core/modules/sistema/enums/roles.enum'
import { ICambioContrasena } from 'src/app/core/modules/sistema/models/ICambioContrasena.interface'
import { SeguridadService } from 'src/app/core/modules/sistema/services/seguridad/seguridad.service'
import { UsuarioService } from 'src/app/core/modules/sistema/services/usuario.service'
import { SpinnerService } from 'src/app/core/services/spinner.service'
import { MessageUtil } from 'src/app/core/utils/message.util'
import { environment } from 'src/environments/environment'
import { CambioContrasenaComponent } from '../../../shared/components/cambio-contrasena/cambio-contrasena.component'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: false,
  styleUrls: ['./header.component.css'],
  providers: [DialogService],
})
export class HeaderComponent implements OnInit {
  private document = inject<Document>(DOCUMENT)
  private _router = inject(Router)
  private _spinnerService = inject(SpinnerService)
  private _seguridadService = inject(SeguridadService)
  private _usuarioService = inject(UsuarioService)

  dialogService = inject(DialogService)

  public version: string = environment.version
  public nombreUsuario: string = ''
  public nombreRol: string = ''
  public nombreCuenta: string = ''
  public esAdministrador: boolean = false
  public esImpersonado = false
  public regresando = false

  public modalRef: DynamicDialogRef | undefined | null

  public cuentaId: number = 0
  public usuarioRol: string = ''
  public rol: string = ''

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[])

  constructor() {}

  ngOnInit(): void {
    this.esImpersonado = this._seguridadService.esUsuarioImpersonado()
    if (!this._seguridadService.esSesionActiva()) {
      return
    }

    this.nombreUsuario = this._seguridadService.obtenerNombreUsuario()
    this.nombreRol = this._seguridadService.obtenerNombreRol()
    this.nombreCuenta = this._seguridadService.obtenerNombreCuenta()
    this.cuentaId = this._seguridadService.obtenerCuenta()
    this.rol = this._seguridadService.obtenerRol()
    this.esAdministrador = this._seguridadService.obtenerRol() === ROLES.Administrador

  }

  sidebarToggle() {
    //toggle sidebar function
    this.document.body.classList.toggle('toggle-sidebar')
  }

  public finalizarImpersonacion(): void {
    if (this.regresando) return
    this.regresando = true
    this._seguridadService.regresarAlUsuarioOriginal()
  }

  public logout(): void {
    if (this.esImpersonado) { this.finalizarImpersonacion(); return }
    this._seguridadService.logout().subscribe({
      next: (_) => {
        console.info('HeaderComponent: logout')
      },
      error: () => {
        this._seguridadService.limpiarSesion()
        this._router.navigate(['/main'])
      },
      complete: () => {
        this._seguridadService.limpiarSesion()
        this._router.navigate(['/main'])
      },
    })
  }

  public cambiarContrasena(): void {
    this.modalRef = this.dialogService.open(CambioContrasenaComponent, {
      header: 'Cambiando contraseña',
      draggable: true,
      width: '30%',
      closable: true,
      modal: true,
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      data: {
        usuarioId: +this._seguridadService.obtenerUsuarioId(),
      },
    })

    this.modalRef?.onClose.subscribe((cambioContrasena?: ICambioContrasena) => {
      if (cambioContrasena) {
        this._spinnerService.show()
        this._usuarioService.cambiarContrasena(cambioContrasena).subscribe({
          next: (_) => {
            MessageUtil.showSuccess('La contraseña fue actualizada con exito!, usala en el proximo inicio de sesion')
          },
          error: (e) => {
            this._spinnerService.hide()
            MessageUtil.showError(e)
          },
          complete: () => {
            this._spinnerService.hide()
          },
        })
      }
    })
  }

  public cambiarCuenta(): void {
    this._router.navigate(['/main/inicio'])
  }


}